export default "__VITE_ASSET__CkPJ6JMS__"